import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { NavService } from '../services/nav.service';
import { AuthService} from '../auth/auth.service';
import { TranslatorService } from '../services/translate.service';


@Component({
  selector: 'app-cancellations-approval',
  templateUrl: './cancellations-approval.component.html',
  styleUrls: ['./cancellations-approval.component.scss']
})
export class CancellationsApprovalComponent implements OnInit {
  ss:any;
  user:any;
  sended: boolean = false;
  cancellationsApprovalUrl: SafeResourceUrl;
  title = "Approvazione Storni";
  subTitle = "EDAC - Approvazione Storni";
  innerHeight: any;
  constructor(public navService: NavService, public translate: TranslatorService, private authService: AuthService) { }


  ngDoCheck() {

    if (this.sended == false) {
      var frame: HTMLIFrameElement = document.getElementById('CancellationsApprovalIframe') as HTMLIFrameElement;
      if (frame != null) {
        this.sended = true;
        frame.contentWindow?.postMessage('sstorage', this.ss);
        this.cancellationsApprovalUrl = environment.rootCancellationsApproval + this.user.sub;
      }
    }

  }

  loadLabels(){
    this.translate.get('SIDEBAR.Approvazione Storni').subscribe(res => {
      this.title = res;
      this.subTitle = "EDAC - " + res;
    })
  }

  ngOnInit(): void {
    this.ss = window.sessionStorage;
    this.user =  this.authService.user();
    console.log('send message to iframe %o',this.ss,this.user);
    this.loadLabels();
    this.navService.setTitle(this.title);
    this.navService.setSubTitle(this.subTitle);
this.navService.setWikiKey('NODEF');
    let actions : any;
    actions = [
    ];
    this.navService.setActions(actions);
    this.innerHeight = (window.innerHeight - 74) + 'px';
  }

}


